import { IArticlesData, IArticlesAction } from 'models/magazine/article/articles';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IStore } from 'redux/IStore';
import * as moment from 'moment';

/** Action Types */
export const REQUEST_RECENT_START: string = 'recentarticles/REQUEST_RECENT_START';
export const REQUEST_RECENT_FAILURE: string = 'recentarticles/REQUEST_RECENT_START';
export const GET_MOST_READ_SUCCESS: string = 'recentarticles/GET_MOST_READ_SUCCESS';

/** Initial State */
const initialState: IArticlesData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	userId: null,
	lastSearchedKeyword: null,
};

/** Reducer */
export function recentArticlesReducer(state = initialState, action: IArticlesAction) {
	switch (action.type) {
		case REQUEST_RECENT_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_RECENT_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_MOST_READ_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getMostReadArticles() {
	return (dispatch, getState: () => IStore) => {
		if (
			getState().recentArticles &&
			getState().recentArticles.items &&
			getState().recentArticles.items.length > 0 &&
			getState().recentArticles.items[0].languageKey === getState().userLanguage.languageKey
		) {
			return;
		}
		dispatch(requestStart());

		const fromDate = moment().add(-7, 'd');
		const toDate = moment();
		const language = getState().userLanguage.languageKey;

		const data: any = {
			FromDate: fromDate,
			ToDate: toDate,
			CurrentPage: 1,
			ItemsPerPage: 3,
			LanguageKey: language,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/MostReadArticles',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(data),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getArticlesSuccess(res.items));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IArticlesAction {
	return {
		type: REQUEST_RECENT_START,
	};
}

/** Action Creator */
export function getArticlesSuccess(items: IArticleListCard[]): IArticlesAction {
	return {
		type: GET_MOST_READ_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticlesAction {
	return {
		type: REQUEST_RECENT_FAILURE,
		payload: {
			message,
		},
	};
}
